import { useEffect, useState } from "react"
import testingServices from "./TestingService"
import { Survey } from 'survey-react';
import 'survey-react/survey.css';
const Testing2=()=> {
    const[formJson,setFormJson]=useState("")
    useEffect(()=>{
        testingServices.GetFormJson(1).then((response)=>{
            if(response.status)
            {
                setFormJson(response.resultData.formJson)
            }
        })
        .catch((error)=>{
            console.log(error)
        })

    },[])
  return (
    <>
    {formJson!==""&&<Survey json={formJson} data={{
    question1: "John Doe",
    question2: "Item 1"
  }} />}
    
    </>
  )
}
export default Testing2